import { app } from '$lib/stores/app/store';
import { user } from '$lib/stores/user/store';
import { get } from 'svelte/store';
import { PAGES, QUERY_PARAM_KEYS } from '$lib/utils/constants';
import { postAuthenticationPathService } from '$lib/services/post-authentication-path';

export const LOGIN_EXCEPTION_HANDLER = async () => {
	return PAGES.INTERNAL.LOGIN;
};

export const ROUTE_TO_NMHP_HANDLER = async () => {
	return PAGES.INTERNAL.HOME;
};

export const REG_PATH_EXCEPTION_HANDLER = async () => {
	const currentUser = get(user);
	return postAuthenticationPathService.getRedirectPath(currentUser);
};

export const ROUTE_TO_PARENT_SECTION_HANDLER = async () => {
	return PAGES.INTERNAL.PARENT_SECTION.DEFAULT;
};

export const SUBSCRIPTION_ACCOUNT_GATE_EXCEPTION_HANDLER = async () => {
	const currentUser = get(user);
	const isInApp = get(app).meta.inApp;
	if (!isInApp && (!currentUser.tokenValid || !currentUser.hasCredentials)) {
		const to = encodeURIComponent(window.location.pathname + window.location.search);
		return `${PAGES.INTERNAL.CREATE_ACCOUNT}?${QUERY_PARAM_KEYS.GOTO}=${to}`;
	}
	return REG_PATH_EXCEPTION_HANDLER();
};

export const OFFER_ACCOUNT_GATE_EXCEPTION_HANDLER = async () => {
	const currentUser = get(user);
	const isInApp = get(app).meta.inApp;
	if (!isInApp && (!currentUser.tokenValid || !currentUser.hasCredentials)) {
		const { pathname, search } = window.location;
		const match = pathname.match(/\/subscription\/offer\/([^/]+)/);
		const hash = match?.[1];
		const to = encodeURIComponent(pathname + search);
		return hash
			? `${PAGES.INTERNAL.CREATE_ACCOUNT}/offer/${hash}?${QUERY_PARAM_KEYS.GOTO}=${to}`
			: `${PAGES.INTERNAL.CREATE_ACCOUNT}?${QUERY_PARAM_KEYS.GOTO}=${to}`;
	}
	return REG_PATH_EXCEPTION_HANDLER();
};
